export const FETCH_AFFILIATE_INVOICE_LIST = {
  START: "FETCH_AFFILIATE_INVOICE_LIST_START",
  SUCCESS: "FETCH_AFFILIATE_INVOICE_LIST_SUCCESS",
  ERROR: "FETCH_AFFILIATE_INVOICE_LIST_ERROR",
};

export const GENERATE_AFFILIATE_INVOICE = {
  START: "GENERATE_AFFILIATE_INVOICE_START",
  SUCCESS: "GENERATE_AFFILIATE_INVOICE_SUCCESS",
  ERROR: "GENERATE_AFFILIATE_INVOICE_ERROR",
};

export const DOWNLOAD_AFFILIATE_INVOICE = {
  START: "DOWNLOAD_AFFILIATE_INVOICE_START",
  SUCCESS: "DOWNLOAD_AFFILIATE_INVOICE_SUCCESS",
  ERROR: "DOWNLOAD_AFFILIATE_INVOICE_ERROR",
};

export const UPDATE_AFFILIATE_INVOICE = {
  START: "UPDATE_AFFILIATE_INVOICE_START",
  SUCCESS: "UPDATE_AFFILIATE_INVOICE_SUCCESS",
  ERROR: "UPDATE_AFFILIATE_INVOICE_ERROR",
};

export const TOAST = {
  RESET: "AFFILIATE_INVOICE_TOAST_RESET",
};

export const FETCH_AFFILIATE_INVOICE_PAYMENTS = {
  START: "FETCH_AFFILIATE_INVOICE_PAYMENTS_START",
  SUCCESS: "FETCH_AFFILIATE_INVOICE_PAYMENTS_SUCCESS",
  ERROR: "FETCH_AFFILIATE_INVOICE_PAYMENTS_ERROR",
};

export const RECORD_AFFILIATE_PAYMENT = {
  START: "RECORD_AFFILIATE_PAYMENT_START",
  SUCCESS: "RECORD_AFFILIATE_PAYMENT_SUCCESS",
  ERROR: "RECORD_AFFILIATE_PAYMENT_ERROR",
};

export const UPDATE_AFFILIATE_PAYMENT = {
  START: "UPDATE_AFFILIATE_PAYMENT_START",
  SUCCESS: "UPDATE_AFFILIATE_PAYMENT_SUCCESS",
  ERROR: "UPDATE_AFFILIATE_PAYMENT_ERROR",
};

export const GET_AFFILIATE_INVOICE_DETAIL = {
  START: "GET_AFFILIATE_INVOICE_DETAIL_START",
  SUCCESS: "GET_AFFILIATE_INVOICE_DETAIL_SUCCESS",
  ERROR: "GET_AFFILIATE_INVOICE_DETAIL_ERROR",
};

export const FETCH_AFFILIATE_INVOICE_INIT = "FETCH_AFFILIATE_INVOICE_INIT";

export const SET_AFFILIATE_INVOICE_FILTERS = "SET_AFFILIATE_INVOICE_FILTERS";
export const CLEAR_AFFILIATE_INVOICE_FILTERS = "CLEAR_AFFILIATE_INVOICE_FILTERS";
export const SAVE_AFFILIATE_INVOICE_TABLE_STATE = "SAVE_AFFILIATE_INVOICE_TABLE_STATE";
